module.exports = __webpack_public_path__ + "static/media/studyEdu.9482db2f.png";